/**
 * @file
 * @auth Tangting
 * @date 2017/2/15
 */

import Vue from 'vue';
import tpl from './tpl.html';

import BlockInfo from './blockInfo/main';
import commonService from '../../common/commonService';
import Firefly from '../../component/Firefly.vue';
//
export default Vue.extend({
    name: 'index',
    template: tpl,
    data(){
        return {
            searchTxt : '',
            bkColor: false, // 控制输入框样式的属性
            isFocus:false, // 控制输入框样式的属性
            blockList : [],
            dealList : [],
            currentHourTransNum: 0,
            topHourTransNum: 0,
            totalAcctNum: 0,
            totalContractNum: 0,
            totalTransAmount: 0,
            totalTransNum: 0
        }
    },
    mounted(){
        this.wave(document.getElementById("canvas"),{
            height: 90,
            waveLength: 500,
            curveFactor: 1,
            speed: -1,//速度
            opacity:'rgba(255,255,255,.1)'
        });
        this.wave(document.getElementById("canvas1"),{
            height: 80,
            waveLength: 600,
            curveFactor: 1,
            speed: -2,//速度
            opacity:'rgba(255,255,255,.2)'
        });
        this.wave(document.getElementById("canvas2"),{
            height: 60,
            waveLength: 700,
            curveFactor: 1,
            speed: -3,//速度
            opacity:'rgba(255,255,255,.3)'
        });
        this.wave(document.getElementById("canvas3"),{
            height: 40,
            waveLength: 800,
            curveFactor: 1,
            speed: -4,//速度
            opacity:'rgba(255,255,255,.45)'
        });
        this.wave(document.getElementById("canvas4"),{
            height: 20,
            waveLength: 900,
            curveFactor: 1,
            speed: -5,//速度
            opacity:'rgba(255,255,255,.6)'
        });
    },
    created() {
        window.scrollTo(0,0);
        this.renderFetchStatic();
        this.renderBlockList();
        this.renderDealList();

        localStorage.removeItem('blockPageNo');
        localStorage.removeItem('agentPageNo');
        localStorage.removeItem('blockNum');
        localStorage.removeItem('TradePageNo');
    },
    // mounted(){ // 问题：放在这儿飘带不显示
    //     window.scrollTo(0,0);
    // },
    components: {
        BlockInfo,
        Firefly
    },
    watch: {
        'isFocus':function(val,oldVal){
            // console.log(val);
            // console.log(oldVal);
        }
    },
    methods: {
        renderFetchStatic(){
            commonService.onLoopStatistic((rep)=>{
                    this.currentHourTransNum = rep.result.currentHourTransNum;
                    this.topHourTransNum = rep.result.topHourTransNum;
                    this.totalAcctNum = rep.result.totalAcctNum;
                    this.totalContractNum = rep.result.totalContractNum;
                    this.totalTransAmount = (rep.result.totalTransAmount/100000).toFixed(2);
                    this.totalTransNum = rep.result.totalTransNum;
            })
        },
        toSearch(){
            if(!this.searchTxt){
                return;
            }else if(this.searchTxt<=0){
                window.toast("没有查询到相关数据");
                return;
            }
            commonService.queryType({"keyword" : this.searchTxt}).done((rep)=>{
                if(rep.result.record_num==0){
                    window.toast("没有查询到相关数据");
                    return;
                }
                let searchType = rep.result.query_type;
                if(searchType == 0){ // 区块hash
                    location.hash = '#/blockInfo?blockHash='+this.searchTxt;
                }else if(searchType == 1){ // 区块高度
                    location.hash = '#/blockInfo?blockNum='+this.searchTxt;
                }else if(searchType == 2){ // 交易id
                    location.hash = '#/tradeInfo?tradeId='+this.searchTxt;
                }else if(searchType == 3){ // 账户地址
                    location.hash= '#/searchResult?fromAddress='+this.searchTxt;
                }else if(searchType == 4){ // 账户名称
                    location.hash = '#/searchResult?fromAcctSpecial='+this.searchTxt;
                }else{
                    window.toast("没有查询到相关数据");
                }
            }).fail((rep)=> {
                window.error("网络异常，请稍后再试");
            });
        },
        toHover(){
            this.bkColor = true;
        },
        renderBlockList(){
            commonService.onLoopBlockList((rep)=>{
                this.blockList = rep.result.dataList;
            })
        },
        renderDealList(){
            commonService.onLoopDealList((rep)=>{
                let listArr = rep.result.dataList;
                listArr.forEach(function(deal,index){
                    let type = deal.trx_type;
                    listArr[index].trxType =
                        type == 0?'普通转账':
                        type == 1?'代理领工资':
                        type == 2?'账户注册':
                        type == 3?'注册代理':
                        type == 4?'升级代理':
                        type == 5?'更新账户':
                        type == 10?'合约注册':
                        type == 11?'合约充值':
                        type == 12?'合约升级':
                        type == 13?'合约销毁':
                        type == 14?'合约调用':
                        type == 15?'合约出账':'';
                });
                this.dealList = listArr;
            })
        },
        wave(canvas,config){
            var ctx = canvas.getContext('2d');
            var stageWidth = 0;
            var stageHeight = 0;
            var stageWidth2 = 0;
            var stageHeight2 = 0;
            var totalLength2 = 0;
            var distanceX = 0;
            var DELTA_WIDTH = 1;
            function init(){
                window.onresize = onResize;
                onResize();
                render();
            }
            function onResize(){
                stageWidth = canvas.width = 2400;
                stageHeight = canvas.height = 380;
                stageWidth2 = stageWidth / 2;
                stageHeight2 = stageHeight / 2;
                totalLength2 = Math.ceil(stageWidth2 / DELTA_WIDTH) * DELTA_WIDTH;
                redraw();
            }
            function render(){
                redraw();
                requestAnimationFrame(render);
            }
            function _getHeight(distanceX, x) {
                var offsetX = ((distanceX + x) /totalLength2 - 1) * (totalLength2 / config.waveLength);
                var waveFactor = Math.cos((x / totalLength2 - 1) * Math.PI / 2);
                return Math.cos(offsetX * Math.PI) * Math.pow(waveFactor, config.curveFactor) * config.height;
            }
            function redraw(){
                var x = stageWidth2 - totalLength2;
                var toX = x + totalLength2 * 2;
                var centerY = stageHeight2;
                //挖空
                ctx.clearRect(0, 0, stageWidth, stageHeight);
                //椭圆
                ctx.beginPath();
                //把新窗口移动到指定的坐标
                ctx.moveTo(x, stageHeight);
                //绘制路径
                for(; x < toX; x+=DELTA_WIDTH){
                    ctx.lineTo(x, centerY - _getHeight(distanceX, x));
                }
                ctx.lineTo(x-DELTA_WIDTH, stageHeight);
                //ctx.lineWidth = 4;
                //ctx.strokeStyle = '#81ecff';
                ctx.globalAlpha=0.5;
                ctx.fillStyle = config.opacity;
                //填充颜色
                ctx.fill();
                //绘制路径
                // ctx.stroke();
                distanceX+=config.speed;

            }
            init();
        }
    }
});



// WEBPACK FOOTER //
// ./src/module/index/main.js